import type { PlayerTransactionRow } from '@/api/generated/models/playerTransactionRow'

/**
 * Transaction description, ported from history.asp:164-194 (the Type 1..11 switch).
 * Type 4 (trade) returns text only when tradeId is set; the page renders the trade
 * link separately. Type 10 with from===to renders nothing (legacy no-op).
 */
export function transactionText(row: PlayerTransactionRow): string {
  const from = row.from ?? null
  const to = row.to ?? null
  switch (row.type) {
    case 1: return `Drafted by ${to} as part of the new team draft.`
    case 2: return `Drafted by ${to} at Round #${row.round}, Position #${row.pos}`
    case 3: return `Signed from Free Agency by ${to}`
    case 4: return row.tradeId != null ? `Traded from ${from} to ${to}` : ''
    case 5: return `Signed from Free Agency by the scout for ${to}`
    case 6: return `Retired from ${from ?? 'Free Agency'}`
    case 7: return `Released by ${from}`
    case 10: return from === to ? '' : `Moved from ${from} to ${to} via the Player Reassignment Tool`
    case 11: return `Moved from ${from ?? 'free agency'} to ${to ?? 'free agency'} via the Player Reassignment Tool`
    default: return ''
  }
}
